import React from 'react';
import styles from '../../components/Layout/LayoutOut.module.css';
import LayoutOut from "../../components/Layout/LayoutOut";
import logo from '../../assets/images/elanciaatwork.png';
import PasswordNewForm from "../../components/Login/PasswordNewForm";
import {Link} from "react-router-dom";
import Routing from "../../services/routing";

function PasswordNewPage() {
    return (
        <LayoutOut>
            <Link to={Routing.routes.login} ><img className={styles.logo} alt="elancia" src={logo}/></Link>
            <PasswordNewForm />
        </LayoutOut>
    );
}

export default PasswordNewPage;
